module.exports = __webpack_public_path__ + "static/img/sort1.ad1dead5.png";